import { Button, Grid, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";

export const GridContainerStyled = styling(Grid)((props) => ({
  display: "flex",
  padding: "80px 120px",
  flexDirection: "column",
  alignItems: "center",
  gap: "48px",
  background: "#FCF9F7",

  [props.theme.breakpoints.down("lg")]: {
    padding: "56px 32px",
    gap: "40px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "40px 24px",
    gap: "40px",
    alignItems: "center",
  },
}));

export const CardListContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "32px",
  width: "282px",
  minWidth: "282px",
  padding: "24px 16px",
  borderRadius: "8px",
  border: "2px solid #d5ccf3",
  background: "#FFF",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const TaglineContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "16px",
  alignSelf: "stretch",
  justifyContent: "center",
  width: "100%",
  textAlign: "center",

  [props.theme.breakpoints.down("lg")]: {
    gap: "24px",
    // maxWidth: "392px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    gap: "8px",
    maxWidth: "none",
    alignItems: "center",
    width: "100%",
    textAlign: "center",
  },
}));

export const TaglineTitle = styling(Typography)((props) => ({
  color: "#261754",
  fontSize: "40px",
  fontWeight: "400",
  fontStyle: "normal",
  lineHeight: "48px",
  fontFamily: "Georgia",
  letterSpacing: "0.06px",
  width: "100%",
  maxWidth: "1200px",

  i: {
    fontStyle: "italic",
  },

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "36px",
    lineHeight: "43.2px",
    letterSpacing: "0.36px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "24px",
    lineHeight: "28.8px",
    letterSpacing: "0.036px",
  },
}));

export const TaglineSubtitle = styling(Typography)((props) => ({
  color: "#261754",
  fontFamily: "Inter",
  fontSize: "20px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "30px",
  letterSpacing: "0.03px",
  alignSelf: "stretch",
  maxWidth: "1005px",
  margin: "0 auto",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "22.4px",
  },
}));

export const CardContainer = styling(Grid)((props) => ({
  display: "flex",
  maxWidth: "1200px",
  gap: "24px",
  flexDirection: "row",
  flexWrap: "nowrap",
  justifyContent: "center",
  alignItems: "stretch",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    gap: "24px",
    overflowX: "scroll",
    flexWrap: "nowrap",
    maxWidth: "100%",
    justifyContent: "flex-start",
  },
}));

export const CardImage = styling("img")((props) => ({
  height: "100%",
  width: "100%",
  flexShrink: "0",
  borderRadius: "8px",
  maxHeight: "64px",
  maxWidth: "64px",
  objectFit: "cover",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const CardTextContainer = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: "16px",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    gap: "8px",
    maxWidth: "unset",
  },
}));

export const CardText = styling(Typography)((props) => ({
  color: "#261754",
  fontFamily: props.type == "desc" ? "Inter" : "Inter",
  fontSize: props.type == "desc" ? "16px" : "20px",
  fontStyle: "normal",
  fontWeight: props.type == "desc" ? 400 : 500,
  lineHeight: props.type == "desc" ? "24px" : "25px",
  alignSelf: "stretch",
  letterSpacing: props.type == "desc" ? "0.15px" : "unset",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: props.type == "desc" ? "14px" : "16px",
    lineHeight: props.type == "desc" ? "21px" : "24px",
    letterSpacing: props.type == "desc" ? "unset" : "unset",
  },
}));

export const LineBreak = styling("div")((props) => ({
  width: "1px",
  backgroundColor: "#000",
  margin: "0",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
    height: "1px",
  },
}));

export const ButtonStyled = styling(Button)((props) => ({
  display: "flex",
  minWidth: "240px",
  width: "fit-content",
  padding: "12px 24px",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  textTransform: "capitalize",
  border: "1px solid #F1CC44",
  background: "linear-gradient(180deg, #FFE36A 50%, #FFC400 122.92%)",
  boxShadow: "0 2px 4px 0 rgba(104, 77, 0, 0.40)",
  color: "rgba(0, 0, 0, 0.87)",
  textAlign: "center",
  borderRadius: "10px",
  height: "54px",
  fontSize: "20px",
  fontWeight: "700",
  lineHeight: "30px",
  letterSpacing: "0.1px",

  ":hover": {
    background: "linear-gradient(180deg, #FFE36A 50%, #FFC400 122.92%)",
    fontWeight: 700,
  },

  [props.theme.breakpoints.down("lg")]: {
    minWidth: "220px",
    height: "48px",
    padding: "12px 24px",
    fontSize: "16px",
    lineHeight: "24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
  },
}));
export const LogoContainer = styling(Grid)((props) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "80px",
  padding: "12px",
  minWidth: "144px",

  cursor: "pointer",

  [props.theme.breakpoints.down("lg")]: {
    height: "70px",
    padding: "10px",
    minWidth: "120px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    height: "60px",
    padding: "8px",
    minWidth: "100px",
  },
}));

export const LogoStyled = styling("img")((props) => ({
  height: "100%",
  objectFit: "contain",
  maxWidth: "unset",
  maxHeight: "72px",
  backgroundSize: "contain",
  width: "100%",

  [props.theme.breakpoints.down("lg")]: {
    maxHeight: "64px",
    maxWidth: "200px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxHeight: "42px",
    maxWidth: "150px",
  },
}));

export const TrustedCompanyGrid = styling(Grid)((props) => ({
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)", // 4 per row
  gap: "48px 24px",
  padding: "0px",
  background: "transparent",
  justifyItems: "center",
  alignItems: "center",
  maxWidth: "1200px",

  [props.theme.breakpoints.down("lg")]: {
    gridTemplateColumns: "repeat(3, 1fr)", // 3 per row
    justifyContent: "center",
    gap: "48px 24px",
    padding: "0px 24px",
  },

  [props.theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "repeat(2, 1fr)", // 2 per row
    gap: "24px",
    padding: "0px 16px",
  },
}));

export const CarouselContainer = styling(Grid)((props) => ({
  // maxWidth: "1220px",
  // padding: "0px 200px",
  height: "100%",
  maxWidth: "1240px",

  [props.theme.breakpoints.down("lg")]: {
    // maxWidth: "720px",
    padding: "0px 0px",
  },

  // [props.theme.breakpoints.down("tablet")]: {
  //   maxWidth: "100%",
  // },
}));

export const CompanyButtons = styling("a")((props) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexShrink: 0,
  borderRadius: "16px",
  border: "none",
  background: "#F7F7FF",
  alignContent: "center",

  "&:hover": {
    border: "none",
  },

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {},
}));
